import {
  CLEANUP,
  SET_LOADING,
  SET_MODALVISIBLE,
  SET_UPLOADEDFILES,
  SET_UPLOADEDFILETYPES,
  SET_SELECTEDTYPE,
  ADD_UPLOADEDFILE,
  ADD_UPLOADEDFILETYPE,
  ADD_UPLOADEDFILENAME,
  ADD_UPLOADEDFILESIZE,
  DELETE_UPLOADEDFILE,
} from "./documentUploadType";

const initialState = {
  loading: false,
  modalVisible: false,
  uploadedFiles: [],
  uploadedFileTypes: [],
  uploadedFilenames: [],
  uploadedFileSizes: [],
  selectedType: null,
  error: "",
};

const documentUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEANUP: {
      return initialState;
    }

    case SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }

    case SET_MODALVISIBLE: {
      return {
        ...state,
        modalVisible: action.modalVisible,
      };
    }

    case SET_UPLOADEDFILES: {
      return {
        ...state,
        uploadedFiles: action.uploadedFiles,
      };
    }

    case SET_UPLOADEDFILETYPES: {
      return {
        ...state,
        uploadedFileTypes: action.uploadedFileTypes,
      };
    }

    case ADD_UPLOADEDFILE: {
      var array = state.uploadedFiles;
      return {
        ...state,
        uploadedFiles: [...array, action.uploadedFile],
      };
    }

    case ADD_UPLOADEDFILETYPE: {
      var array = state.uploadedFileTypes;
      return {
        ...state,
        uploadedFileTypes: [...array, action.uploadedFileType],
      };
    }

    case ADD_UPLOADEDFILENAME: {
      var array = state.uploadedFilenames;
      return {
        ...state,
        uploadedFilenames: [...array, action.uploadedFilename],
      };
    }

    case ADD_UPLOADEDFILESIZE: {
      var array = state.uploadedFileSizes;
      return {
        ...state,
        uploadedFileSizes: [...array, parseInt(action.uploadedFileSize)],
      };
    }

    case SET_SELECTEDTYPE: {
      return {
        ...state,
        selectedType: action.selectedType,
      };
    }

    case DELETE_UPLOADEDFILE: {
      var index = action.index;
      return {
        ...state,
        uploadedFiles: [
          ...state.uploadedFiles.slice(0, index),
          ...state.uploadedFiles.slice(index + 1),
        ],
        uploadedFilenames: [
          ...state.uploadedFilenames.slice(0, index),
          ...state.uploadedFilenames.slice(index + 1),
        ],
        uploadedFileSizes: [
          ...state.uploadedFileSizes.slice(0, index),
          ...state.uploadedFileSizes.slice(index + 1),
        ],
        uploadedFileTypes: [
          ...state.uploadedFileTypes.slice(0, index),
          ...state.uploadedFileTypes.slice(index + 1),
        ],
      };
    }

    default:
      return state;
  }
};

export default documentUploadReducer;
